import { defineMessages } from "react-intl";

const messages = defineMessages({
  amountRequired: {
    id: "dealPane.amount.error.required",
    defaultMessage: "Amount is a required field for this layout. Please enter a value.",
    description: "Validation error shown when user tries to remove required amount field value",
  },
  closingDateRequired: {
    id: "dealPane.closingDate.error.required",
    defaultMessage: "Closing Date is a required field for this layout. Please enter a value.",
    description:
      "Validation error shown when user tries to remove required closingDate field value",
  },
  lossComment: {
    id: "dealPane.dealLoss.lossComment",
    defaultMessage: "Loss Comment",
    description: "Loss Comment",
  },
  lossReason: {
    id: "dealPane.dealLoss.lossReason",
    defaultMessage: "Loss Reason",
    description: "Loss Reason",
  },
  missingFieldsButton: {
    id: "dealPane.dealLoss.missingFields.button",
    defaultMessage: "Fill Out",
    description: "Fill Out - button text",
  },
  missingFieldsText: {
    id: "dealPane.dealLoss.missingFields.text",
    defaultMessage: "Fill out required fields to change to this stage",
    description: "Fill out required fields to change to this stage - message text",
  },
  noComment: {
    id: "dealPane.dealLoss.noComment",
    defaultMessage: "No comment",
    description: "Displaying No Comment",
  },
});

export default messages;
